module.exports = __webpack_public_path__ + "ce8797b08e9b466c6c8ded1a3fec707c.svg";